export const xmlToJson = (xmlString) => {

  if (xmlString) {
    if (isXml(xmlString)) {
      let parser = new DOMParser();
      let xml = parser.parseFromString(xmlString, 'text/xml');
      var strVale = xml.getElementsByTagName('ECG')[0].textContent.split(/[ ,]+/).join(',');
      var strArr = strVale.split(',');
      var intArr = [];
      for (var i = 0; i < strArr.length; i++) {
        intArr.push(parseInt(strArr[i]));
      }
      return intArr;
    }
  }
};

function isXml(input) {

  if (typeof input !== 'string') return false;

  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(input, 'application/xml');

    // Si hay errores de parseo, el XML tiene un nodo <parsererror>
    const isParserError = doc.getElementsByTagName('parsererror').length > 0;
    return !isParserError;
  } catch (e) {
    return false;
  }
}
